import { useEffect, useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { FormSchema, type FormValues, initialFormValues } from '../../schemas';
import type { BoPhan, BoPhanInput } from '@/types/schemas';
import { BasicInfoTab } from './BasicInfoTab';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
  open: boolean;
  initialData?: BoPhan;
  onSubmit?: (data: BoPhanInput) => void;
  onClose: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  zIndex?: number;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  zIndex
}: FormDialogProps) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);

  useEffect(() => {
    if (!open) {
      setIsFormDirty(false);
    }
  }, [open]);

  const handleSubmit = (data: FormValues) => {
    onSubmit?.(data);
    setIsFormDirty(false);
    onClose();
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục bộ phận'}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
        zIndex={zIndex}
      >
        <AritoFormV2
          mode={formMode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          onClose={onClose}
          initialData={initialData || initialFormValues}
          className='w-[800px] overflow-y-auto'
          headerFields={
            <div onChange={() => setIsFormDirty(true)}>
              <BasicInfoTab formMode={formMode} />
            </div>
          }
          bottomBar={
            <BottomActionBarV2
              mode={formMode}
              onClose={onClose}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              onCopy={onCopy}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default FormDialog;
